module.exports = __webpack_public_path__ + "static/media/spacer.72a87c2c.svg";